var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.824 35.1348V29.1554L40.6679 28.1654V35.1337C40.408 34.9458 40.0952 34.8209 39.7409 34.8209C39.3865 34.8232 39.0838 34.9379 38.824 35.1348Z",
    fill: "#747474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3543 41.2501H17.2498C16.9786 41.2501 16.7705 41.4684 16.7705 41.7294C16.7705 41.9904 16.9888 42.2086 17.2498 42.2086H25.3543C25.6141 42.2086 25.8335 41.9904 25.8335 41.7294C25.8335 41.4684 25.6153 41.2501 25.3543 41.2501Z",
    fill: "#747474"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.636 33.8964V45.0001H29.9689V33.8964L21.5527 38.4065C21.4695 38.4481 21.3862 38.4695 21.303 38.4695C21.2197 38.4695 21.1264 38.4481 21.0532 38.4065L12.636 33.8964ZM15.6982 41.7297C15.6982 40.8759 16.3957 40.1772 17.2507 40.1772H25.3552C26.2091 40.1772 26.9077 40.8747 26.9077 41.7297C26.9077 42.5847 26.2102 43.2822 25.3552 43.2822H17.2507C16.3856 43.2811 15.6982 42.5937 15.6982 41.7297Z",
    fill: "#747474"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.323 32.1144V44.99H11.5629V33.3125L9.323 32.1144Z",
    fill: "#747474"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.042 33.3125V44.99H33.2819V32.1144L31.042 33.3125Z",
    fill: "#747474"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3027 16.7704L2.14624 27.0518L9.02111 30.7395C9.03124 30.7496 9.05261 30.7496 9.06274 30.7609L12.3331 32.5215C12.3432 32.5316 12.3646 32.5316 12.3747 32.5429L21.3016 37.3343L30.2285 32.5429C30.2386 32.5328 30.26 32.5328 30.2701 32.5215L33.5405 30.771C33.5506 30.7609 33.572 30.7609 33.5821 30.7496L40.457 27.0619L21.3027 16.7704Z",
    fill: "#747474"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4487 11.583C34.3441 11.6876 34.2091 11.7394 34.0741 11.7394C33.9391 11.7394 33.7928 11.6764 33.6995 11.583L32.3033 10.1869C32.0952 9.97876 32.0952 9.63451 32.3033 9.42638C32.5115 9.21826 32.8557 9.21826 33.0638 9.42638L34.0842 10.4468L38.7192 5.80051C38.9273 5.59238 39.2716 5.59238 39.4797 5.80051C39.6878 6.00863 39.6878 6.35288 39.4797 6.56101L34.4487 11.583ZM29.6157 8.68726C29.6157 12.1354 32.4282 14.9479 35.8763 14.9479C39.3245 14.9479 42.137 12.1354 42.137 8.68726C42.137 5.23913 39.3245 2.42664 35.8763 2.42664C32.4282 2.42664 29.6157 5.22901 29.6157 8.68726Z",
    fill: "#747474"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2089 8.68727C43.2089 12.7294 39.9171 16.0211 35.875 16.0211C31.8329 16.0211 28.5411 12.7294 28.5411 8.68727C28.5411 4.64514 31.8329 1.35339 35.875 1.35339C39.9272 1.35452 43.2089 4.64627 43.2089 8.68727ZM27.1877 8.68727C27.1877 13.4786 31.0836 17.3745 35.875 17.3745C40.6664 17.3745 44.5622 13.4786 44.5622 8.68727C44.5622 3.89589 40.6675 1.96399e-05 35.875 1.96399e-05C31.0836 -0.0101054 27.1877 3.89589 27.1877 8.68727Z",
    fill: "#747474"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.43774 8.68726C2.43774 12.1354 5.25024 14.9479 8.69837 14.9479C12.1465 14.9479 14.959 12.1354 14.959 8.68726C14.959 5.23913 12.1465 2.42664 8.69837 2.42664C5.24012 2.42664 2.43774 5.22901 2.43774 8.68726ZM6.88599 11.7394C6.73974 11.7394 6.60474 11.6764 6.51137 11.583L5.11524 10.1869C4.90712 9.97876 4.90712 9.63451 5.11524 9.42638C5.32337 9.21826 5.66762 9.21826 5.87574 9.42638L6.89612 10.4468L11.5311 5.80051C11.7392 5.59238 12.0722 5.59238 12.2916 5.80051C12.4997 6.00863 12.4997 6.35288 12.2916 6.56101L7.27074 11.5819C7.16724 11.6775 7.03112 11.7394 6.88599 11.7394Z",
    fill: "#747474"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0312 8.68727C16.0312 12.7294 12.7395 16.0211 8.69737 16.0211C4.65525 16.0211 1.3635 12.7294 1.3635 8.68727C1.3635 4.64514 4.65525 1.35339 8.69737 1.35339C12.7395 1.35339 16.0312 4.64627 16.0312 8.68727ZM0 8.68727C0 13.4786 3.89587 17.3745 8.68725 17.3745C13.4786 17.3745 17.3745 13.4786 17.3745 8.68727C17.3745 3.89589 13.4797 1.96399e-05 8.68837 1.96399e-05C3.90712 -0.0101054 0 3.89589 0 8.68727Z",
    fill: "#747474"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7405 43.677C40.5345 43.677 41.1782 41.9373 41.1782 39.7913C41.1782 37.6452 40.5345 35.9055 39.7405 35.9055C38.9464 35.9055 38.3027 37.6452 38.3027 39.7913C38.3027 41.9373 38.9464 43.677 39.7405 43.677Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.08491180c0f708c8d8f13cb809120605.svg";
export { ForwardRef as ReactComponent };